module.exports = __webpack_public_path__ + "static/media/chart.924a0e4f.svg";